/* cf-preview-legible.js - Click Fencing
 * Preview drawing: readable measurements, fixed drawing height, scroll instead of squash.
 *
 * WHY: the preview <svg> is width:100% with max-height:130px while its artwork is ~206
 * user-units tall. preserveAspectRatio therefore scales the whole drawing to ~0.63 and
 * letterboxes it, so the 9px labels render at 5.7 CSS px and ~64% of the panel sits empty.
 *
 * WHAT: give the drawing a fixed rendered HEIGHT, let its width follow the fence so the
 * scale never changes, scroll horizontally when it is wider than the panel (a scale
 * drawing must never be squashed), and size each <text> in user units so it always lands
 * at TARGET_PX on screen.
 *
 * TRAP THIS COST A ROUND TRIP: enlarging the labels grows the SVG's getBBox(), so
 * re-measuring after a pass shrinks the scale, which enlarges the labels again - a
 * runaway loop that ended at 7.3px on mobile. Every SVG is therefore measured EXACTLY
 * ONCE, from its authored artwork, and stamped `data-cf-fixed`. Never re-measure a
 * bbox after touching a font-size.
 */
(function () {
  if (window.__cfPreviewLegibleInstalled) return;
  window.__cfPreviewLegibleInstalled = true;

  var DRAW_H_DESKTOP = 140;   // rendered height of the artwork, px
  var DRAW_H_MOBILE  = 120;
  var TARGET_PX      = 11.5;  // on-screen size for small part labels
  var TARGET_PX_DIM  = 13.5;  // on-screen size for the larger dimension labels
  var MAX_UPSCALE    = 4;     // never blow a label up more than this vs authored

  function drawH() { return window.innerWidth < 768 ? DRAW_H_MOBILE : DRAW_H_DESKTOP; }

  function tidy(sp) {
    sp.style.setProperty('overflow-x', 'auto', 'important');
    sp.style.setProperty('overflow-y', 'hidden', 'important');
    sp.style.setProperty('overscroll-behavior-x', 'contain', 'important');
    sp.style.setProperty('padding-top', '4px', 'important');
    sp.style.setProperty('padding-bottom', '2px', 'important');
    var pc = sp.querySelector('.panels-container');
    if (pc) {
      pc.style.setProperty('overflow', 'visible', 'important');
      pc.style.setProperty('padding-top', '0px', 'important');
      pc.style.setProperty('align-items', 'flex-end', 'important');
      pc.style.setProperty('width', 'auto', 'important');
      pc.style.setProperty('min-width', '100%', 'important');
    }
  }

  function fixSvg(svg) {
    /* NOT THE GLASS RAKE PANEL. Added 2026-09-02.

       This file was written for the ONE fence-wide drawing that blade, flat top and mesh
       render inside #section-preview - a wide artwork full of <text> dimension labels that
       needs a fixed readable height. The frameless glass calculator is different: it draws
       each panel separately, and a raked panel gets its OWN little inline <svg> inside a
       .panel-preview, sitting in a row of plain <div> panels sized by CSS.

       "#section-preview svg" matches those per-panel artworks too, so this was pinning a
       rake panel to a flat 140px regardless of how tall the panels beside it were. It has no
       <text> in it at all, so it gained nothing and lost its scale - and because
       cf-glass-preview-fixes.js pushed the intrinsic size back on its own timer, the two
       files alternated and the panel visibly flickered. Pete, 2026-09-02: "the rake panels
       still look awful ... also it cant flicker like it does. fix this for good."

       A rake panel must be sized RELATIVE TO ITS NEIGHBOURS, not to a constant, so it is
       owned by cf-rake-align.js and skipped here. The test is the .panel-preview ancestor:
       the fence-wide drawing this file exists for never has one. */
    if (svg.closest && svg.closest('.panel-preview')) return;

    var H = drawH();
    if (svg.getAttribute('data-cf-fixed') === String(H)) return;   // already done at this size

    // --- measure ONCE, from the authored artwork -----------------------------
    var vb0 = svg.getAttribute('data-cf-vb0');
    if (!vb0) {
      var bb;
      try { bb = svg.getBBox(); } catch (e) { return; }
      if (!bb || !bb.width || !bb.height) return;
      var padX = 6, padY = 2;
      vb0 = (bb.x - padX).toFixed(1) + ' ' + (bb.y - padY).toFixed(1) + ' ' +
            (bb.width + padX * 2).toFixed(1) + ' ' + (bb.height + padY * 2).toFixed(1);
      svg.setAttribute('data-cf-vb0', vb0);
    }
    var v = vb0.split(' ').map(Number);
    var vbW = v[2], vbH = v[3];
    if (!vbW || !vbH) return;

    svg.setAttribute('viewBox', vb0);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    var scale = H / vbH;
    svg.style.setProperty('height', H + 'px', 'important');
    svg.style.setProperty('width', Math.round(vbW * scale) + 'px', 'important');
    svg.style.setProperty('max-width', 'none', 'important');
    svg.style.setProperty('max-height', 'none', 'important');
    svg.style.setProperty('flex', 'none', 'important');
    svg.style.setProperty('display', 'block', 'important');

    // --- size the labels so they land at TARGET_PX on screen -----------------
    var texts = svg.querySelectorAll('text');
    for (var i = 0; i < texts.length; i++) {
      var t = texts[i];
      var authored = parseFloat(t.getAttribute('data-cf-fs0'));
      if (isNaN(authored)) {
        authored = parseFloat(t.getAttribute('font-size'));
        if (isNaN(authored)) authored = parseFloat(getComputedStyle(t).fontSize) || 9;
        t.setAttribute('data-cf-fs0', authored);
      }
      var want = (authored >= 12 ? TARGET_PX_DIM : TARGET_PX) / scale;
      if (want > authored * MAX_UPSCALE) want = authored * MAX_UPSCALE;
      // NOTE: cf-mobile.liquid floors `svg text { font-size: 11px }` with !important on
      // phones, and a presentation ATTRIBUTE loses to any stylesheet rule - that is why an
      // earlier build still measured 7.3px on mobile. Set it as an important inline style.
      if (want > authored) {
        t.setAttribute('font-size', want.toFixed(2));
        t.style.setProperty('font-size', want.toFixed(2) + 'px', 'important');
      }
    }
    svg.setAttribute('data-cf-fixed', String(H));
  }

  var busy = false;
  function run() {
    if (busy) return;
    busy = true;
    try {
      var sp = document.querySelector('#section-preview');
      if (sp) {
        tidy(sp);
        var svgs = sp.querySelectorAll('svg');
        for (var i = 0; i < svgs.length; i++) fixSvg(svgs[i]);
      }
    } catch (e) { /* a display fix must never break the calculator */ }
    busy = false;
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function boot() {
    var host = document.querySelector('.calculator-page') || document.body;
    if (!host) return;
    try { new MutationObserver(schedule).observe(host, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('resize', function () {
      // a breakpoint change needs a re-fit: clear the stamps, keep the cached viewBoxes
      var sp = document.querySelector('#section-preview');
      if (sp) sp.querySelectorAll('svg[data-cf-fixed]').forEach(function (s) { s.removeAttribute('data-cf-fixed'); });
      schedule();
    });
    schedule();
    var n = 0, t = setInterval(function () { schedule(); if (++n > 40) clearInterval(t); }, 500);
    console.log('[cf-preview-legible] installed');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
